import type { Point, Viewport } from "@/src/types/map";

const MIN_ZOOM = 0.2;
const MAX_ZOOM = 4;

export class Camera {
  static clampZoom(zoom: number): number {
    return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, zoom));
  }

  static screenToWorld(point: Point, viewport: Viewport): Point {
    return [
      (point[0] - viewport.x) / viewport.zoom,
      (point[1] - viewport.y) / viewport.zoom,
    ];
  }

  static worldToScreen(point: Point, viewport: Viewport): Point {
    return [
      point[0] * viewport.zoom + viewport.x,
      point[1] * viewport.zoom + viewport.y,
    ];
  }

  static zoomAt(viewport: Viewport, screenPoint: Point, nextZoom: number): Viewport {
    const zoom = Camera.clampZoom(nextZoom);
    const worldPoint = Camera.screenToWorld(screenPoint, viewport);

    return {
      x: screenPoint[0] - worldPoint[0] * zoom,
      y: screenPoint[1] - worldPoint[1] * zoom,
      zoom,
    };
  }

  static pan(viewport: Viewport, delta: Point): Viewport {
    return {
      ...viewport,
      x: viewport.x + delta[0],
      y: viewport.y + delta[1],
    };
  }
}

export const snapToGrid = (value: number, gridSize: number): number =>
  Math.round(value / gridSize) * gridSize;

export const snapPointToGrid = (point: Point, gridSize: number): Point => [
  snapToGrid(point[0], gridSize),
  snapToGrid(point[1], gridSize),
];

